define(function (require) {
	"use strict";
	var LE = require("app");
	var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
	var LobView = require("personalization-user-management-views/LobView");
	var BaseModel = require("models/BaseModel");
	var SiteSettingsModel = require("models/SiteSettingsModel");
	var Settings = require("codeTables/settings.json");

	var LobController = {};
	function moduleDefinition(LEPersonalization, LE, Backbone, Marionette, $, _) {

		LobController = BaseFeatureController.extend({
			initialize: function (options) {
				LEPersonalization.logger.info("initializing", "LobController:initialize", options);
				this.featureId = options.featureOptions.id;
				this.siteSettingsModel = new SiteSettingsModel({
					id: Settings.SETTING_ID.LOB_ENABLED,
					contextType: Settings.CONTEXT_TYPE.ACCOUNT,
					contextCascading: true
				});
				this.lobView = new LobView({
					anchorSelector:options.featureOptions.anchorSelector,
					featureId:this.featureId
				});
				this.listenTo(this.lobView, "lob:navigateToFeatureEdit", this._onNavigateToFeatureEdit, this);
				this._fetchSiteSettingsModel();
			},
			getAnchorView: function (options) {
				LEPersonalization.logger.debug("return this view", "LobController:getAnchorView", options);
				return this.lobView;
			},
			_onNavigateToFeatureEdit: function () {
				LEPersonalization.logger.debug("navigates to feature edit controller", "LobController:_onNavigateToFeatureEdit");
				LEPersonalization.navigateToFeatureEdit({
					featureId: this.featureId,
					controllerOptions:{
						siteSettingsModel: this.siteSettingsModel
					}
				});
			},
			_onSiteSettingsFetchSuccess: function (model, response) {
				LEPersonalization.logger.debug("When data fetch was successful", "LobController:_onSiteSettingsFetchSuccess", response);
				var lobSiteSettingValue = this.siteSettingsModel.getValue() === "true";
				this.lobView.setLobValue(lobSiteSettingValue);
				if (lobSiteSettingValue) {
					this._fetchLobsCollection();
				} else {
					this.lobView.setUiState();
				}
			},
			_onSiteSettingsFetchError: function (model, response) {
				LEPersonalization.logger.debug("When data fetch has resulted with an error", "LobController:_onSiteSettingsFetchError", response);
				LEPersonalization.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1100"));
			},
			_fetchSiteSettingsModel: function() {
				LEPersonalization.logger.debug("Retrieve the settings model", "LobController:_getSettingsCollection");
				var settingsOptions = {
					success: _.bind(this._onSiteSettingsFetchSuccess, this),
					error: _.bind(this._onSiteSettingsFetchError, this)
				};
				this.siteSettingsModel.fetch(settingsOptions);
			},
			_fetchLobsCollection: function () {
				LEPersonalization.logger.debug("Retrieve the lobs collection", "LobController:_fetchLobsCollection");
				this.lobsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getLobsCollection);
				var lobsCollectionOptions = {
					success: _.bind(this._onFetchLobsSuccess, this),
					error: _.bind(this._onFetchLobsError, this)
				};
				this.lobsCollection.fetch(lobsCollectionOptions);
			},

			_onFetchLobsSuccess: function (response) {
				LEPersonalization.logger.debug("fetch lobs collection success", "LobController:_onFetchLobsSuccess", response);
				var isExistingLobs = (this.lobsCollection.length > 0);
				this.lobView.setUiState(isExistingLobs);
			},

			_onFetchLobsError: function (response) {
				LEPersonalization.logger.debug("fetch lobs error", "LobController:_onFetchLobsError", response);
				LEPersonalization.notifier.showError({
					content: LE.translator.translate("LEFramework.errors.serverError.1100"),
					timeToShow: 6000
				});
			}
		});
	}

	LE.module("LEPersonalization", moduleDefinition);

	return LobController;
});
